// extracted by mini-css-extract-plugin
export default {"loading":"loading-screen_loading__vcwNt","loading-image":"loading-screen_loading-image__LWCea"};